module.exports = __webpack_public_path__ + "img/pirze_img_quo.f9c7ff6e.png";